import {
  type EntityParty,
  PartyDesignation,
  PartyRole,
} from "@digits-graphql/frontend/graphql-bearer"

export const VENDOR_PARTY_ROLES = [
  PartyRole.EntityVendorRole,
  PartyRole.EntitySupplierRole,
  PartyRole.EntityAssetVendorRole,
  PartyRole.EntityPrepaidVendorRole,
]

export const CUSTOMER_PARTY_ROLES = [
  PartyRole.EntityCustomerRole,
  PartyRole.EntityRevenuePartnerRole,
]

export const MISSING_PARTY_ID = "missing-party-id"
export const MISSING_PARTY_ENTITY: EntityParty = {
  id: MISSING_PARTY_ID,
  designation: PartyDesignation.UnknownDesignation,
  name: "",
}
